<template>
    <div class="bbp-timer-modal-panel">
      <BBPTimerModalPanelCounter
        :start="isStart"
        :isPause="isPause"
        :activeTimer="activeTimer"
      />
      <div class="bbp-timer-modal-panel-buttons">
        <button
          :class="[
            'bbp-button',
            'bbp-timer-modal-panel__button',
             disabledStart && 'bbp-timer-modal-panel__button_disabled'
          ]"
          @click="onButtonStart"
        >
          <span v-html="PLAY_ICON()"/>
          start
        </button>
        <button
          :class="[
            'bbp-button',
            'bbp-timer-modal-panel__button',
            'bbp-timer-modal-panel__button_pause',
            disabledButton && 'bbp-timer-modal-panel__button_disabled'
          ]"
          @click="onButtonPause"
        >
          <span v-html="isPause ? PAUSE_ICON() : PLAY_ICON()"/>
        </button>
        <button
          :class="[
            'bbp-button',
            'bbp-timer-modal-panel__button',
            'bbp-timer-modal-panel__button_stop',
            disabledButton && 'bbp-timer-modal-panel__button_disabled'
          ]"
          @click="onButtonStop"
        >
          <span v-html="STOP_ICON()"/>
          stop
        </button>
        <button
          :class="[
            'bbp-button',
            'bbp-timer-modal-panel__button',
            'bbp-timer-modal-panel__button_delete',
            disabledDelete && 'bbp-timer-modal-panel__button_delete-disabled',
            disabledDelete && 'bbp-timer-modal-panel__button_disabled',
          ]"
          @click="onButtonDelete"
        >
          <span v-html="DELETE_ICON()" />
        </button>
      </div>
      <transition name="bbp-fade" mode="out-in">
        <BBPModalWindow v-if="isShowDeleteModal">
          <BBPTimerModalDelete
            btnTextRight="YES"
            @close="isShowDeleteModal = false"
            @handlerClick="onDelete"
          />
        </BBPModalWindow>
      </transition>
    </div>
</template>

<script>
import { PLAY_ICON, STOP_ICON, PAUSE_ICON, DELETE_ICON } from '@/constants/icons'
import { TIMER_STATUS } from '@/constants/timerStatus'
import { HOURLY, SIDE_HOURLY } from '@/constants/projectTypes'
import { REMINDER_STATUS } from '@/constants/recurReminders'
import BBPTimerModalPanelCounter
  from '@/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalPanel/BBPTimerModalPanelCounter'
import TimerApi from '@/api/Timer/api'
import BBPTimerModalDelete from '@/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalDelete'
import BBPModalWindow from '@/components/Main/BBPModalWindow/BBPModalWindow'

export default {
  name: 'BBPTimerModalPanel',
  components: {
    BBPTimerModalPanelCounter,
    BBPTimerModalDelete,
    BBPModalWindow
  },
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Object,
      default: () => ({})
    },
    comment: {
      type: String,
      default: ''
    },
    isError: {
      type: Boolean,
      default: false
    },
    body: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    isShowDeleteModal: false,
    PLAY_ICON,
    STOP_ICON,
    PAUSE_ICON,
    DELETE_ICON
  }),
  computed: {
    activeTimerStatus () {
      const { subTimers = {} } = this.activeTimer
      const { status } = subTimers
      return status
    },
    disabledButton () {
      return this.error || TIMER_STATUS.COMPLETED === this.activeTimerStatus || this.isStart
    },
    disabledStart () {
      const { childrenProjects = [], projectType = {} } = this.row
      const disabled = this.error || !this.isStart || TIMER_STATUS.COMPLETED === this.activeTimerStatus
      if (HOURLY.id === projectType.id) {
        return !childrenProjects.length || disabled
      }
      return disabled
    },
    disabledDelete () {
      const { subTimers = {} } = this.activeTimer
      return this.error || Object.keys(subTimers).length === 0 || TIMER_STATUS.SAVED === this.activeTimerStatus
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    error: {
      get () {
        return this.isError
      },
      set (data) {
        this.$emit('update:isError', data)
      }
    },
    isStart: {
      get () {
        return this.$store.getters.isStart
      },
      set (data) {
        this.$store.dispatch('setStart', data)
      }
    },
    isPause: {
      get () {
        return this.$store.getters.isPause
      },
      set (data) {
        this.$store.dispatch('setPause', data)
      }
    },
    activeTimer: {
      get () {
        return this.$store.getters.activeTimer
      },
      set (data) {
        this.$store.dispatch('setActiveTimer', data)
      }
    },
    time: {
      get () {
        return this.$store.getters.time
      },
      set (data) {
        this.$store.dispatch('setTimer', data)
      }
    },
    instanceStatus () {
      const { instanceStatus } = this.column
      return instanceStatus
    },
    isProjectTimer () {
      return REMINDER_STATUS.PROJECT === this.instanceStatus
    },
    isSubproject () {
      const { projectType = {} } = this.row
      return projectType.id === SIDE_HOURLY.id
    }
  },
  methods: {
    async onButtonStart () {
      await this.createTimer()
      this.isStart = !this.isStart
    },
    async onButtonStop () {
      await this.completeTimer()
      this.isStart = !this.isStart
    },
    onButtonPause () {
      this.isPause = !this.isPause
      if (this.isPause) {
        this.createTimer()
      } else {
        this.pauseTimer()
      }
    },
    onButtonDelete () {
      this.isShowDeleteModal = !this.isShowDeleteModal
    },
    async onDelete () {
      this.isShowDeleteModal = false
      this.isStart = true
      const { subTimers = {} } = this.activeTimer
      const { _id } = subTimers
      try {
        await TimerApi.deleteTimer(_id)
        this.activeTimer = {
          ...this.activeTimer,
          subTimers: {}
        }

        this.time = {
          ...this.time,
          hours: '00',
          minutes: '00',
          seconds: '00'
        }
        if (!this.isPause) this.isPause = true
      } catch (err) {
        console.error(err)
      }
    },
    addCurrentStatusActiveTimer (status) {
      const { subTimers = {} } = this.activeTimer
      subTimers.status = status
    },
    async createTimer () {
      const { subprojectId, project, requestProject, subTimers = {} } = this.activeTimer
      const body = {
        user: this.userInfo ? this.userInfo.id : '5f8097e4e06d0800124c7a5d',
        startDate: new Date(),
        project: this.isProjectTimer ? subprojectId ? [project, subprojectId] : [project] : undefined,
        request: this.isProjectTimer ? undefined : [requestProject],
        instanceStatus: this.instanceStatus,
        subTimerId: subTimers._id,
        isSub: this.isSubproject
      }
      try {
        const { data } = await TimerApi.createTimer(body)
        const { _id, isSub } = data
        const { subTimers = {} } = this.activeTimer
        this.activeTimer = {
          ...this.activeTimer,
          instanceStatus: this.instanceStatus,
          subTimers: {
            ...subTimers,
            status: TIMER_STATUS.ACTIVE,
            _id,
            isSub
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    async pauseTimer () {
      if (!this.isPause) this.addCurrentStatusActiveTimer(TIMER_STATUS.PAUSE)
      const { subprojectId, project, requestProject, subTimers = {}, isSub } = this.activeTimer
      const body = {
        user: this.userInfo ? this.userInfo.id : '5f8097e4e06d0800124c7a5d',
        endDate: this.time.fullDate,
        project: this.isProjectTimer ? subprojectId ? [project, subprojectId] : [project] : undefined,
        request: this.isProjectTimer ? undefined : [requestProject],
        instanceStatus: this.instanceStatus,
        subTimerId: subTimers._id,
        isSub
      }
      try {
        const { data } = await TimerApi.pauseTimer(body)
        const { _id } = data
        const { subTimers = {} } = this.activeTimer
        this.activeTimer = {
          ...this.activeTimer,
          subTimers: {
            ...subTimers,
            _id
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    async completeTimer () {
      const { subprojectId, project, requestProject, subTimers = {} } = this.activeTimer
      const body = {
        user: this.userInfo ? this.userInfo.id : '5f8097e4e06d0800124c7a5d',
        endDate: this.time.fullDate,
        project: this.isProjectTimer ? subprojectId ? [project, subprojectId] : [project] : undefined,
        request: this.isProjectTimer ? undefined : [requestProject],
        instanceStatus: this.instanceStatus,
        subTimerId: subTimers._id,
        ...this.body
      }
      try {
        await TimerApi.completeTimer(body)
        this.addCurrentStatusActiveTimer(TIMER_STATUS.COMPLETED)
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style  lang="scss" scoped>
@import "../../../../../../sass/variables";

  .bbp-timer-modal-panel {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__button {
      width: 86px;
      display: flex;
      align-items: center;
      justify-content: center;
      grid-gap: 0 4px;
      height: 36px;
      font-size: 13px;
      font-weight: 600;
      line-height: 16px;
      padding: 10px 19px;

      &_stop {
        width: 80px;
        background: $color-pomegranate;

        &:hover {
          opacity: 0.85;
          transition: 0.15s;
        }
      }

      &_pause {
        width: 36px;
        padding: 0;

        span {
          display: flex;
        }
      }

      &_delete {
        width: 36px;
        background: $color-wild-sand !important;

        &:hover {
          opacity: 0.85;
          transition: 0.15s;
        }
      }

      &_disabled {
        background: $color-silver;
        pointer-events: none;
      }
    }
  }

  .bbp-timer-modal-panel-buttons {
    display: flex;
    grid-gap: 0 5px;
  }
</style>

<style lang="scss">
@import "../../../../../../sass/variables";

  .bbp-timer-modal-panel__button {

    &_delete-disabled svg path {
      fill: $color-silver;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalPanel/BBPTimerModalPanel.vue